import {PriceRobotMessage} from "./price-robot-message";
import {BehaviorSubject, Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {Location} from "@angular/common";
import {AuthService, BaseService} from "@hassel-it/angular-common";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class PriceRobotMessageService extends BaseService {
    private _message: BehaviorSubject<PriceRobotMessage> = new BehaviorSubject(new PriceRobotMessage('', false));

    public readonly message: Observable<PriceRobotMessage> = this._message.asObservable();

    constructor(public http: HttpClient, public authService: AuthService, private router: Router, private location: Location) {
        super(http, authService);
    }

    getMessage(): Observable<PriceRobotMessage> {
        return this.message;
    }

    setError(error: string) {
        this._message.next(new PriceRobotMessage(error, true));
    }

    setMessage(message: string, isError: boolean) {
        this._message.next(new PriceRobotMessage(message, isError));
    }

    handleError(error: any) {
        if (error.status === 401) {
            this.setError('Ugyldig token');
            this.authService.logout();
            this.router.navigateByUrl('/login');
        } else if (error.status === 404) {
            // @todo this.router.navigateByUrl('/notfound');
        } else if (error.status === 500) {
            this.setError('Der skete en server fejl - prøv igen senere');
            this.location.back();
        } else {
            this.setError(error.error);
        }
    }
}
